import { splice } from './splice.ts';

/**
 * Creates a new array with the given value removed.
 */
export function removeValue<T>(arr: readonly T[], value: T | undefined): T[] {
  const index = value === undefined ? -1 : arr.indexOf(value);

  if (index === -1) {
    return [...arr];
  }

  return splice(arr, index, 1);
}